import { useCallback, useEffect, useState } from 'react';

import { SingleSelection } from '../../../../components';
import { SelectChangeEvent } from '../../../../components/MuiGenerals';
import { useTranslation } from '../../../../hooks';
import { EnumCreditCardStatus } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/ApiEnum';

interface IProps {
  label?: string;
  value: any;
  onChange: (e: SelectChangeEvent) => void;
  onClear: () => void;
}

const StatusSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { translate, tc } = useTranslation();
  const t = (key: string) => translate(`enumConstants.${key}`);

  return (
    <SingleSelection
      label={label || tc('phSelection', { fieldName: tc('status') })}
      value={value || ''}
      clearSelect={onClear}
      onChange={onChange}
      enumData={EnumCreditCardStatus}
      nameFn={(name: string) => {
        return t(`${name}`);
      }}
    />
  );
};

export default StatusSingleSelection;
